import { useMemo } from 'react';
import { createPreset } from './presets.mjs';

function usePreset(preset, options) {
  const plugins = useMemo(() => createPreset(preset, options), [preset, options]);
  return {
    plugins
  };
}

export { usePreset };
